<div class="h-[73px] bg-gray-950 w-full pr-10">
  <div class="flex flex-row justify-end h-full items-center">
    <div class="flex flex-row items-center gap-3">
      <div class="w-[40px] h-[40px] rounded-full bg-white">
        <img src="assets/img/icon-holder.jpg" alt="Image" class="w-full h-full rounded-full object-cover">
      </div>
      <div class="flex flex-col">
        <div class="text-gray-400 text-[0.9rem]">{{loggedInUserName}}</div>
        <div>
          <div *ngIf="loggedUser.userType === SETTINGS.USERS.ADMIN">
            <div class="text-accent font-bold" *ngIf="loggedInUser.role === 'SUPER_ADMIN'">Super Admin</div>
            <div class="text-accent font-bold" *ngIf="loggedInUser.role === 'ADMIN'">Admin</div>
            <div class="text-accent font-bold" *ngIf="loggedInUser.role === 'SUPPORT'">Support</div>
            <div class="text-accent font-bold" *ngIf="loggedInUser.role === 'STAFF'">Staff</div>
          </div>
          <div *ngIf="loggedUser.userType === SETTINGS.USERS.MEMBER" class="text-accent">Member</div>
        </div>

        <!-- <div class="text-accent" *ngIf="loggedInUser.role !== 'SUPER_ADMIN'">{{loggedInUser.role}}</div> -->
      </div>
    </div>
  </div>
</div>